<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">Registro Geral</h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">
            Aqui você acompanha as principais métricas e resumos do sistema, incluindo envios, conversas e centros de
            custo.
          </p>
        </div>
      </div>

      <div class="mb-10 grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">

        <div role="button" tabindex="0" @click="selectCard('enviados')" @keyup.enter="selectCard('enviados')"
          :class="cardClass('enviados')">
          <div class="mb-10 flex items-center gap-3">
            <span class="flex h-10 w-10 items-center justify-center rounded-xl" :style="iconBadgeStyle">
              <svg class="h-6 w-6" :style="{ color: primaryColor }" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" stroke-width="2">
                <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
            </span>
            <h2 class="text-lg font-medium text-gray-800">{{ $store.getters.rotuloEnvio('Enviados', 'Enviados para fila') }}</h2>
          </div>

          <div class="text-3xl font-medium text-gray-900">
            {{ formatNumber(relatorio.massivo) }}
          </div>

          <p class="mt-10 text-sm text-gray-400">
            Envios direcionados para as filas de disparo.
          </p>
        </div>

        <div role="button" tabindex="0" @click="selectCard('conversas')" @keyup.enter="selectCard('conversas')"
          :class="cardClass('conversas')">
          <div class="mb-3 flex items-center gap-3">
            <span class="flex h-10 w-10 items-center justify-center rounded-xl" :style="iconBadgeStyle">
              <svg class="h-6 w-6" :style="{ color: primaryColor }" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" stroke-width="2">
                <path
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </span>
            <h2 class="text-lg font-medium text-gray-800">Conversas</h2>
          </div>

          <div class="h-40">
            <ChartLine :labels="conversasLabels" :values="conversasData" :color="primaryColor" />
          </div>
        </div>

        <div role="button" tabindex="0" @click="selectCard('respostas')" @keyup.enter="selectCard('respostas')"
          :class="cardClass('respostas')">
          <div class="mb-10 flex items-center gap-3">
            <span class="flex h-10 w-10 items-center justify-center rounded-xl" :style="iconBadgeStyle">
              <svg class="h-6 w-6" :style="{ color: primaryColor }" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" stroke-width="2">
                <path
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </span>
            <h2 class="text-lg font-medium text-gray-800">Novos Chats</h2>
          </div>

          <div class="text-3xl font-medium text-gray-900">
            {{ formatNumber(relatorio.conversas) }}
          </div>

          <p class="mt-10 text-sm text-gray-400">
            Novos chats iniciados hoje.
          </p>
        </div>

        <div role="button" tabindex="0" @click="selectCard('centros')" @keyup.enter="selectCard('centros')"
          :class="cardClass('centros')">
          <div class="mb-10 flex items-center gap-3">
            <span class="flex h-10 w-10 items-center justify-center rounded-xl" :style="iconBadgeStyle">
              <svg class="h-6 w-6" :style="{ color: primaryColor }" fill="none" stroke="currentColor"
                viewBox="0 0 24 24" stroke-width="2">
                <path
                  d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M12 15a3 3 0 100-6 3 3 0 000 6z" />
              </svg>
            </span>
            <h2 class="text-lg font-medium text-gray-800">
              Centros de Custo
            </h2>
          </div>


          <div class="text-3xl font-medium text-gray-900">
            {{ formatNumber(relatorio.centrocustos) }}
          </div>

          <p class="mt-10 text-sm text-gray-400">
            Centros de custo cadastrados.
          </p>
        </div>

      </div>

    </div>

    <div class="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10">

      <div class="dashboard-card-shadow rounded-2xl bg-white p-6">
        <h2 class="mb-4 text-xl font-normal text-gray-800">
          Respostas
        </h2>

        <div class="h-64">
          <ChartBar :labels="respostasLabels" :values="respostasData" :color="primaryColor" />
        </div>
      </div>

      <div class="dashboard-card-shadow rounded-2xl bg-white p-6">
        <h2 class="mb-4 text-xl font-normal text-gray-800">
          Envios Massivos por Data
        </h2>

        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-left text-sm text-gray-600">
            <thead>
              <tr class="border-b border-gray-500 text-gray-500">
                <th class="pb-3 font-medium">Data</th>
                <th class="pb-3 font-medium">Envios</th>
                <th class="pb-3 font-medium">Envio Manual</th>
                <th class="pb-3 font-medium">Retornos</th>
                <th class="pb-3 font-medium">Percentual</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in tabela" :key="item.data" class="border-b border-gray-400">
                <td class="py-3 text-gray-500">{{ item.data }}</td>
                <td class="py-3">
                  <a class="hover:underline text-gray-800">{{ formatNumber(item.envios) }}</a>
                </td>
                <td class="py-3 font-medium">
                  <a class="hover:underline text-gray-800">{{ formatNumber(item.enviosManuais || 0) }}</a>
                </td>
                <td class="py-3 text-gray-600">{{ formatNumber(item.retornos) }}</td>
                <td class="py-3">
                  <span class="text-gray-800">{{ item.percentual }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ChartBar from "../../components/ChartBar.vue";
import ChartLine from "../../components/ChartLine.vue";

export default {
  components: {
    ChartBar,
    ChartLine
  },

  data() {
    return {
      selectedCard: null,

      relatorio: {
        massivo: 0,
        conversas: 0,
        centrocustos: 0
      },

      conversasLabels: [],
      conversasData: [],
      respostasLabels: [],
      respostasData: [],
      tabela: []
    };
  },

  computed: {
    primaryColor() {
      const color = this.$store.state.colorPrincipal || "#2f4f4f";
      // Validar se é um hex válido (3 ou 6 dígitos)
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color)) {
        return color;
      }
      return "#2f4f4f";
    },

    iconBadgeStyle() {
      return {};
    }
  },

  methods: {
    cardClass(card) {
      return [
        "dashboard-card-shadow h-full cursor-pointer rounded-2xl bg-white p-6 transition-all duration-300",
        "hover:-translate-y-1 hover:shadow-xl hover:ring-1 hover:ring-gray-200",
        this.selectedCard === card ? "ring-2 ring-cyan-200" : ""
      ];
    },

    selectCard(card) {
      this.selectedCard = this.selectedCard === card ? null : card;
    },

    formatNumber(value) {
      return Number(value || 0).toLocaleString("pt-BR");
    },

    hexToRgba(hexColor, alpha = 1) {
      if (!hexColor || typeof hexColor !== "string") {
        return `rgba(47, 79, 79, ${alpha})`;
      }

      const normalized = hexColor.replace("#", "");
      const full = normalized.length === 3
        ? normalized
          .split("")
          .map((char) => char + char)
          .join("")
        : normalized;

      if (full.length !== 6) {
        return `rgba(47, 79, 79, ${alpha})`;
      }

      const r = parseInt(full.slice(0, 2), 16);
      const g = parseInt(full.slice(2, 4), 16);
      const b = parseInt(full.slice(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },

    async start() {
      if (!this.$store.state.user || !this.$store.state.user._id) {
        if (this.$route.name !== "login") {
          this.$router.push("/login");
        }
        return;
      }

      const loader = this.$loading.show({
        container: null,
        canCancel: true
      });

      try {
        const listReq = await this.$http.post("/v1/chatV2/relatorio-home");

        const categorias = Array.isArray(listReq.data.categorias)
          ? listReq.data.categorias
          : [];

        const grafico = Array.isArray(listReq.data.grafico)
          ? listReq.data.grafico
          : [];

        const percentualRetorno = Array.isArray(
          listReq.data.percentual_retorno
        )
          ? listReq.data.percentual_retorno
          : [];

        let serieConversas = [];

        if (grafico.length && grafico[0] && Array.isArray(grafico[0].data)) {
          serieConversas = grafico[0].data;
        }

        this.relatorio = listReq.data.relatorio || this.relatorio;

        const percentualPorData = percentualRetorno.map((item) =>
          Number(item.porcentagem || 0)
        );
        const labelsGrafico = categorias.length
          ? categorias
          : percentualRetorno.map((item) => item.data);
        const dadosConversas = labelsGrafico.map((label, index) => {
          const valor = serieConversas[index];
          return Number(
            valor === undefined ? percentualPorData[index] || 0 : valor
          );
        });

        this.conversasLabels = labelsGrafico;
        this.conversasData = dadosConversas;

        this.respostasLabels = percentualRetorno.map((item) => item.data);

        this.respostasData = percentualRetorno.map((item) =>
          Number(item.respostas || 0)
        );

        this.tabela = percentualRetorno
          .slice()
          .reverse()
          .filter(
            (item) =>
              Number(
                item.totalEnvios ||
                item.totalEnviados ||
                item.total ||
                item.respostas ||
                0
              ) > 0
          )
          .slice(0, 4)
          .map((item) => ({
            data: item.data,
            envios: item.totalEnvios || item.totalEnviados || item.total || 0,
            enviosManuais: Number(item.totalIniciadoManual || item.totalManual || item.manual || 0),
            retornos: item.respostas || 0,
            percentual: `${item.porcentagem || 0}%`
          }));

      } finally {
        loader.hide();
      }
    }
  },

  beforeMount() {
    this.start();
  }
};
</script>

<style scoped>
.dashboard-card-shadow {
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.1), 0 3px 10px rgba(15, 23, 42, 0.06);
}

.dashboard-card-shadow:hover,
.dashboard-card-shadow:focus {
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.13), 0 6px 16px rgba(15, 23, 42, 0.08);
}
</style>
